import {
    logo,
    negativElev,
    positivELev,
    clockOClock,
    map,
    pace,
    pdfHeaderImg,
  } from "../../assets/encoded-bg-img";

export const PdfExportHeader = (pdf, activityDetails, summaryUnitLabels) => {
    const {
        totalDistanceRounded,
        totalPositiveElevationRounded,
        totalNegativeElevationRounded,
        paceTime,
        activityTime,
      } = activityDetails;
  
    pdf.addImage(pdfHeaderImg, 0, 0, pdf.internal.pageSize.getWidth(), 120);
    pdf.addImage(logo, 10, 6, 37, 9);
    let linkText = `www.waldup.com`;
    pdf.setTextColor("#014d72");
    console.log(pdf.getFont());
    pdf.setFontSize(10);
    pdf.text(linkText, 300, 12, "center");
    pdf.setFontSize(14);
    pdf.setTextColor("#003d73");
    let totaldist = `${totalDistanceRounded} ${summaryUnitLabels[1]}`;
    let totalPosElev = `${totalPositiveElevationRounded} ${summaryUnitLabels[2]}`;
    let totalNegElev = `${totalNegativeElevationRounded} ${summaryUnitLabels[2]}`;
    pdf.setFont('OpenSans-Bold','bold');
    pdf.text(activityDetails.title, 10, 38);
    pdf.setTextColor("#000000")
    pdf.addImage(map, 10, 50, 10, 10);
    pdf.text(totaldist, 25, 60);
    pdf.addImage(positivELev, 90, 50, 12, 12); 
    pdf.text(totalPosElev, 105, 60);
    pdf.addImage(negativElev, 160, 50, 12, 12);
    pdf.text(totalNegElev, 175, 60);
    pdf.addImage(clockOClock, 240, 50, 10, 10);
    pdf.text(activityTime, 255, 60);
    pdf.addImage(pace, 315, 50, 10, 10);
    pdf.text(`${paceTime} ${summaryUnitLabels[0]}`, 330, 60);
    pdf.setFont('OpenSans-Regular','normal');
    let splitDescription = pdf.splitTextToSize(
        activityDetails.description,
        450
    );
    pdf.setFontSize(9);
    pdf.text(splitDescription, 10, 85);
    };